export class GitCommitResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "headSha",
            "baseName": "headSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "commitSha",
            "baseName": "commitSha",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitCommitResult.attributeTypeMap;
    }
    constructor() {
    }
}
